import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, SpeedDatingComponentInterface } from '../../../../../interfaces/pagebuilder';
import VyColorPickerV2 from '../../../../common/VyColorPickerV2';

const SpeedDatingStyling = ({ component, onChange }: ComponentStylingInterface<SpeedDatingComponentInterface>) => {
  const [currComponent, setCurrComponent] = useState(component);
  const { t } = useTranslation('pagebuilder');
  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  return (
    <div className="mt-4" style={{ position: 'relative' }}>
      <div style={{ padding: '10px', position: 'sticky', zIndex: 1 }}>
        <div className="flex flex-col w-full text-black font-bold ">
          <div className="flex flex-row w-full text-slate-700 p-4 z-50">
            <VyColorPickerV2
              title={t('matching.button-bg-color')}
              defaultValue={currComponent?.customStyling?.buttonBackgroundColor}
              onChange={(color) => {
                const _component = {
                  ...currComponent,
                  customStyling: {
                    ...currComponent.customStyling,
                    buttonBackgroundColor: color,
                  },
                };
                onChange(_component);
                setCurrComponent(_component);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col w-full text-black font-bold ">
          <div className="flex flex-row w-full text-slate-700 p-4 z-40">
            <VyColorPickerV2
              title={t('matching.button-text-color')}
              defaultValue={currComponent?.customStyling?.buttonTextColor}
              onChange={(color) => {
                const _component = {
                  ...currComponent,
                  customStyling: {
                    ...currComponent.customStyling,
                    buttonTextColor: color,
                  },
                };
                onChange(_component);
                setCurrComponent(_component);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(SpeedDatingStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
